module.exports = __webpack_public_path__ + "media/images/flags/fo-f284df39e89f9ed508ad86e7b0c7d2ac.svg";